import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {UserService} from './user.service';

@Injectable()
export class ServerService {

  getAll(): Observable<Array<Server>> {
    return this.http.get('/api/servers', {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().data)
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  findById(id: string): Observable<Server> {
    return this.http.get('/api/servers/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  verifyExists(id: string): Observable<boolean> {
    return this.http.get('/api/servers/check/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().id ? true : false)
      .catch((error: any) => {
        if (error.status === 404 && error.json().message === 'SERVER_NOT_FOUND') {
          return Observable.of(false);
        }
        console.log(`Received error:${JSON.stringify(error)}`);
        return Observable.throw(error.json().message || 'Server error');
      });
  };

  save(s: Server): Observable<Server> {
    return this.http.post('/api/servers', s, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  }

  remove(id: string): Observable<string> {
    return this.http.delete('/api/servers/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().id)
      .catch((error: any) => Observable.throw(error.message || 'Server error'));
  }

  constructor(private http: Http, private us: UserService) {
  }
}

export class Server {

  static fromJSON(json: any): Server {
    const object: Server = Object.create(Server.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public id: string, public name: string, public protocol: string, public hostname: string,
              public port: number, public pbxApiPath = '', public latency = -1, public version = '',
              public username = '', public password = '') {
  };
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/server.service.ts